import React, { useEffect } from "react";
import "aos/dist/aos.css";
import AOS from "aos";
import "./email.css";
import { ASSETS_BASE_URL } from "constants";

const Success = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <main className="main section container full-page">
      <div className="d-flex flex-column center-content text-align-center justify-content-center align-items-center">
        <img
          src={`${ASSETS_BASE_URL}assets/images/rize/email/success.svg`}
          alt="Success"
          className="success-img"
        />

        <p className="email-title">You’re all set! Your email is verified.</p>

        <h5 className="email-subtitle">
          Great news – your email is verified! You’re good to go. Your MY alrajhi journey starts here.
        </h5>
      </div>
    </main>
  );
};

export default Success;
